import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { emailValidator } from "../utils/app-validators";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  spinnerType = SPINNER.circle;
  constructor(private ngxService: NgxUiLoaderService, private spinner: NgxSpinnerService, public fb: FormBuilder, public authenticationService: AuthenticationService, public router: Router) {

  }

  ngOnInit(): void {

  }
  public disableAccount(): void {
    this.ngxService.start();
    let data = { isDisable: "false" }
    this.authenticationService.disableAccount(data).subscribe(
      (response: any) => {
        // Swal.fire(
        //   'Disabled!',
        //   'Your account has been disabled.',
        //   'success'
        // )
        Swal.fire({
          title: 'Disable your profile?',
          html: "If you disable your profile, it will be hidden from public view but your information will be preserved. If you have a paid subscription, it will not renew if your profile remains disabled at the expiration of your current subscription.<br> <br>To enable your profile, simply login and it will become publicly visible again.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, disable it!',
          customClass: {
            confirmButton: 'btn btn-warning mr-4',
            cancelButton: 'btn btn-primary'
          },
          buttonsStyling: false 
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire(
              'Great News!',
              'Your Profile is still active!',
              'success'
            )
          }
        })
        this.ngxService.stop();
      },
      error => {
        if (error) {
          Swal.fire(
            "Oops...",
            error.error.message,
            "error"
          );
          this.ngxService.stop();
        }
      }
    );
  }

  public deleteAccount(): void {
    this.ngxService.start();
    this.authenticationService.deleteAccount().subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.authenticationService.logout();
        this.router.navigate(['/login'])
      },
      error => {
        this.ngxService.stop();
        if (error) {
          Swal.fire(
            "error",
            error.error.message
          );

        }
      }
    );
  }
  deleteYourAccount() {
    Swal.fire({
      title: 'Delete Your Profile?',
      html: 'If you delete your profile, your information will be erased and cannot be restored. If you have a paid subscription, it will not renew and you will not receive a refund for your subscription. If you want a profile in the future, you will have to create a new one and paid subscriptions will be at current pricing.<br> <br>Are you sure you want to delete it?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, Keep it',
      customClass: {
        confirmButton: 'btn btn-warning mr-4',
        cancelButton: 'btn btn-primary'
      },
      buttonsStyling: false 
    }).then((result) => {
      if (result.value) {
        this.deleteAccount()
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Great News!',
          'Your profile is still active!',
          'success'
        )
      }
    })
  }
  redirect() {
    this.router.navigate(['/dashboard']);
  }
}
